import styled from 'styled-components'

import { ReactComponent as exclamationRed } from 'resources/images/icons/exclamation-icon-red.svg'
import { ReactComponent as checkCircleOutline } from 'resources/images/icons/checkCircleOutline.svg'
import { COLOURS } from 'resources/constants'

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SpinnerContainer = styled(ContentContainer)`
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const WarningContainer = styled(ContentContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 80px 20px;
  border-radius: 4px;
  background-color: ${COLOURS.neutralGrey1};
`

export const WarningHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-top: 30px;
`

export const WarningSubHeader = styled.div`
  font-size: 18px;
  margin-top: 13px;
`

export const WarningIcon = styled(exclamationRed)`
  width: 50px;
  height: 50px;
`

export const SuccessIcon = styled(checkCircleOutline)`
  width: 50px;
  height: 50px;

  path {
    fill: ${COLOURS.systemGreen1};
  }
`
